import { BubbleIcon, LifebuoyIcon, PaperIcon, PeopleIcon } from './icons';
import { IconBooks } from '@tabler/icons-react';

const host = process.env.NEXT_PUBLIC_HOST_NAME;

const TopLinksData = [
  {
    href: `${host}/help-centre`,
    label: 'Help Centre',
    icon: LifebuoyIcon,
  },
  {
    href: `${host}/contact-us`,
    label: 'Contact Us',
    icon: BubbleIcon,
  },
  {
    href: `${host}/news`,
    label: 'News',
    icon: PaperIcon,
  },
  {
    href: `${host}/guides`,
    label: 'Guides',
    icon: IconBooks,
  },
  {
    href: `${host}/about-us`,
    label: 'About Us',
    icon: PeopleIcon,
  },
];

export const TopLinks = ({ className = '' }: { className: string }) => (
  <div
    className={`bg-background-200 relative z-10 w-full lg:flex lg:items-center lg:border-0 lg:pt-5 ${className}`}
    role="group"
  >
    <div className="tc-container flex flex-col justify-end pl-0 lg:flex-row lg:gap-4">
      {TopLinksData.map((link) => (
        <a
          key={link.label}
          href={link.href}
          className="lg:border-dark-100 bg-background-200 group text-dark-200 hover:border-primary active:bg-background-300 md:bg-background-100 flex h-[40px] items-center text-center text-lg text-[16px] font-medium lg:rounded-md lg:border-[1px] lg:px-3 lg:py-0.5 lg:text-sm lg:font-medium"
        >
          {link.icon && <link.icon className={`stroke-dark-200 mr-2 h-4 w-4`} />}
          {link.label}
        </a>
      ))}
    </div>
  </div>
);
